export default async ({ store, route, redirect }) => {
  const { currentUser } = store.state.auth;
  const spaceId = route.path.split('/')[2];
  const currentSpace = await store.dispatch('space/getSpace', spaceId);
  if (currentSpace.status === 'inactive' || currentSpace.userID !== currentUser.id) {
    return redirect('/space');
  }
};
